<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
import { encrypt, setCookie } from "./utils"

export default {
  name: "app",
  data () {
    return {
      isRouterAlive: true
    };
  },
  provide: function () {
    return {
      reload: this.reload
    }
  },
  mounted () {
    const script = document.createElement("script");
    script.src =
      "https://s95.cnzz.com/z_stat.php?id=1277715118&web_id=1277715118";
    script.language = "JavaScript";
    document.body.appendChild(script);
    if (
      navigator.appVersion.indexOf("MiniProgram") > -1 ||
      navigator.appVersion.indexOf("AlipayIDE") > -1
    ) {
      // eslint-disable-next-line
      my.postMessage({ type: "userinfo" });
      let _this = this;
      // eslint-disable-next-line
      my.onMessage = function (e) {
        if (e.userid) {
          let params = {
            referer: "miniprogram",
            userId: e.userid
          };
          _this.MiniProgramUserInfo(params);
        }
      };
    }
  },
  methods: {
    MiniProgramUserInfo (params) {
      this.$store.dispatch("account/fetchUserData", { params }).then(() => {
        if (this.$store.state.account.user.userid) {
          let account = JSON.stringify(this.$store.state.account.user);
          setCookie("account", encrypt(account), true);
        } else {
          this.$toast("登录失败,请稍后再试");
        }
      });
    },
    reload: function () {
      this.isRouterAlive = false;
      this.$nextTick(function () { this.isRouterAlive = true })
    },
  },
  watch: {
    $route () {
      if (window._czc) {
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = "/";
        window._czc.push(["_trackPageview", contentUrl, refererUrl]);
      }
    }
  }
};
</script>
